import { render } from "./BaseItemsList.vue?vue&type=template&id=3523e790&scoped=true"
import script from "./BaseItemsList.vue?vue&type=script&lang=js"
export * from "./BaseItemsList.vue?vue&type=script&lang=js"

import "./BaseItemsList.vue?vue&type=style&index=0&id=3523e790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3523e790"]])

export default __exports__